export default class Subjects {
    static from(object) {
      try {
        return new Subjects(object);
      } catch (err) {
        console.log("error - no access");
        return err;
      }
    }
  
    constructor(initializer) {
      this.values = initializer;
    }

    get isBased() {
        return this.values != undefined && this.values.length > 0
    }

    get list() {
        return this.values != undefined ? this.values : []
    }

     get systemSubjects() {
        return [
          { id: 1, title: "Physical Education", key_value: "pe", color_hex: "C11E43" },
          { id: 2, title: "Art and Design", key_value: "art",  color_hex: "FF8383"},
          { id: 3, title: "Design & Technology", key_value: "design-tech",  color_hex: "81BFDA" },
          { id: 4, title: "Drama", key_value: "drama",  color_hex: "16404D" },
          { id: 5, title: "Geography", key_value: "geography",  color_hex: "FADA7A" },
          { id: 6, title: "History", key_value: "history",  color_hex: "FFC145" },
          { id: 7, title: "PHSE", key_value: "phse",  color_hex: "FF9874" },
          { id: 8, title: "Science", key_value: "science",  color_hex: "86A788" },
           { id: 9, title: "Music", key_value: "music",  color_hex: "86A788" },
           { id: 10, title: "Maths", key_value: "maths",  color_hex: "86A788" },
           { id: 11, title: "English", key_value: "english",  color_hex: "86A788" },
            { id: 12, title: "Computing", key_value: "computing",  color_hex: "86A788" },
            { id: 13, title: "MFL", key_value: "mfl",  color_hex: "86A788" },
            { id: 14, title: "RE", key_value: "re",  color_hex: "86A788" },
        ];
      }

      get defaultSubject() {
        return this.systemSubjects[0]
      }
}